import { Loader } from '@googlemaps/js-api-loader';
export const API_KEY_ESS = 'AIzaSyCfIll8xIqhliIhY_r_UezpZd-TKxJNx3s';
export const API_KEY_MEP = 'AIzaSyDEdrx2_O_c-m1LkFO6Ef-TWNypjLtCvzQ';
export async function load(site) {
    try {
        // Check for existing SDK.
        if (window.google) {
            return window.google;
        }
        // Load the Google JS SDK.
        const googleApiLoader = new Loader({ apiKey: site === 'ess' ? API_KEY_ESS : API_KEY_MEP });
        const googleApi = await googleApiLoader.load();
        return googleApi;
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}
export async function reverseGeocode(location, site) {
    try {
        // Load the Google JS SDK.
        const googleApi = await load(site);
        // Geocode the coordinates to the location string.
        const geocoder = new googleApi.maps.Geocoder();
        const result = await geocoder.geocode({ location });
        return result;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
export async function geocode(address, site) {
    try {
        // Load the Google JS SDK.
        const googleApi = await load(site);
        // Geocode the coordinates to the location string.
        const geocoder = new googleApi.maps.Geocoder();
        const result = await geocoder.geocode({ address });
        return result;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
